import {
  createDefaultRegulationFolder,
  createGeneralRegulationFolder,
  FolderValues,
} from '../../../types';

const folderPresets: Array<Partial<Omit<FolderValues, 'id'>>> = [
  {name: 'אדמיניסטרציה'},
  {name: 'מונציפלי'},
  {name: 'ציוד'},
  {name: 'שונות'},
];

const buildFolder = (presets: Array<Partial<Omit<FolderValues, 'id'>>>) =>
  presets.map(preset => createDefaultRegulationFolder(preset));

export const getFolders = (): FolderValues[] => [
  createGeneralRegulationFolder(),
  ...buildFolder(folderPresets),
];
